import React from 'react';
import './ios-components.css';

/**
 * Toggle switch estilo iOS
 * Props:
 * - checked: boolean
 * - onChange: (checked: boolean) => void
 * - disabled: boolean
 * - color: string (cor quando ativo, default: #34C759 - iOS green)
 */
function IOSSwitch({ checked, onChange, disabled = false, color = '#34C759' }) {
  const handleClick = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={handleClick}
      disabled={disabled}
      className={`ios-switch ${checked ? 'ios-switch--checked' : ''} ${disabled ? 'ios-switch--disabled' : ''}`}
      style={{ '--switch-active-color': color }}
    >
      <span className="ios-switch__track">
        <span className="ios-switch__thumb" />
      </span>
    </button>
  );
}

export default IOSSwitch;
